import { useState } from 'react';
import { Button, Input } from '@react-apps/design-system';
import { TagChips } from './TagChips';

interface TagListInputProps {
  label: string;
  values: string[];
  placeholder?: string;
  helperText?: string;
  onChange: (values: string[]) => void;
  /**
   * Rótulo exibido no chip para cada valor. O valor bruto continua sendo o que
   * é armazenado/enviado; isto só afeta a exibição (ex.: `scopeId` → "label (id)").
   */
  formatValue?: (value: string) => string;
}

/**
 * Editor de lista de strings (scopeIds, featureIds, targetScopes). Adiciona por
 * Enter ou botão; remove clicando no chip. Evita duplicatas e valores vazios.
 */
export function TagListInput({
  label,
  values,
  placeholder,
  helperText,
  onChange,
  formatValue,
}: TagListInputProps) {
  const [draft, setDraft] = useState('');

  const add = () => {
    const value = draft.trim();
    if (!value || values.includes(value)) {
      setDraft('');
      return;
    }
    onChange([...values, value]);
    setDraft('');
  };

  const remove = (value: string) => {
    onChange(values.filter((v) => v !== value));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      add();
    }
  };

  return (
    <div className="space-y-2">
      {/* O helper fica fora da linha: dentro do `Input` ele entra na altura do
          flex e empurra o botão para baixo do campo (pior ainda quando quebra
          em duas linhas). Aqui o `items-end` alinha o botão com o input. */}
      <div className="flex items-end gap-2">
        <div className="flex-1">
          <Input
            label={label}
            value={draft}
            placeholder={placeholder}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
        <Button type="button" variant="secondary" onClick={add}>
          Adicionar
        </Button>
      </div>
      {helperText && (
        <p className="text-(--color-text-secondary) text-sm">{helperText}</p>
      )}

      <TagChips values={values} onRemove={remove} formatValue={formatValue} />
    </div>
  );
}
